// import { useState, useEffect } from 'react';
// import axios from 'axios';

// const useSalesOrders = ({ id = null, page = 1, perPage = 200, customerId = null } = {}) => {
//   const [data, setData] = useState(id ? null : []);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const resolvedCustomerId = '256873000150456325';

//   useEffect(() => {
//     const fetchSalesOrders = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const url = id
//           ? `http://localhost:5000/api/zoho/salesorder/${id}`
//           : `http://localhost:5000/api/zoho/salesorders/${resolvedCustomerId}`;

//         const params = id
//           ? {}
//           : {
//               page,
//               per_page: perPage,
//               ...(resolvedCustomerId ? { customer_id: "256873000150456325" } : {})
//             };

//         const { data } = await axios.get(url, { params });

//         setData(data);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch sales orders');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSalesOrders();
//   }, [id, page, perPage, resolvedCustomerId]);

//   return { data, loading, error };
// };



// const CUSTOMER_ID = "256873000150456325"; // Hardcoded customer ID

// const useCreateSalesOrder = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [result, setResult] = useState(null);

//   // Accept both items and quantities as arguments
//   const createSalesOrder = async (items, quantities) => {
//     setLoading(true);
//     setError(null);
//     setResult(null);

//     try {
//       const payload = {
//         customer_id: CUSTOMER_ID,
//         line_items: items.map((item, idx) => ({
//           item_id: item.id || item.item_id || "256873000149972193",
//           quantity: quantities[idx] || 1
//         }))
//       };
//       // Debug log
//       console.log('payload:', payload);

//       const { data } = await axios.post(
//         'http://localhost:5000/api/zoho/salesorder',
//         payload
//       );
//       setResult(data);
//       return data;
//     } catch (err) {
//       setError(err.message || 'Failed to create sales order');
//       return null;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { createSalesOrder, loading, error, result };
// };

// export default useSalesOrders;
// export { useCreateSalesOrder };



import { useState, useEffect } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

// const useSalesOrders = ({ id = null, page = 1, perPage = 200, customerId = null } = {}) => {
//   const [data, setData] = useState(id ? null : []);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Get customer ID from localStorage
//   const resolvedCustomerId = (() => {
//     const userData = localStorage.getItem('user');
//     if (!userData) return null;
//     const parsedUser = JSON.parse(userData);
//     return parsedUser?.CustomerID || null;
//   })();

//   useEffect(() => {
//     const fetchSalesOrders = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const url = id
//           ? `http://localhost:5000/api/zoho/salesorder/${id}`
//           : `http://localhost:5000/api/zoho/salesorders/${resolvedCustomerId}`;

//         const params = id
//           ? {}
//           : {
//               page,
//               per_page: perPage,
//               ...(resolvedCustomerId ? { customer_id: resolvedCustomerId } : {})
//             };

//         const { data } = await axios.get(url, { params });

//         setData(data);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch sales orders');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSalesOrders();
//   }, [id, page, perPage, resolvedCustomerId]);

//   return { data, loading, error };
// };

const useCreateSalesOrder = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const getHeaders = () => {
    const userData = localStorage.getItem('user');
    const parsedUser = userData ? JSON.parse(userData) : null;
    const token = parsedUser?.token || parsedUser?.Token || null;
    return {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
    };
  };

  // Accept both items and quantities as arguments
  const createSalesOrder = async (items, quantities) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      // Get customer ID from localStorage
      const userData = localStorage.getItem('user');
      const parsedUser = userData ? JSON.parse(userData) : null;
      const customerId = parsedUser?.CustomerID;

      const payload = {
        customer_id: customerId,
        line_items: items.map((item, idx) => ({
          item_id: item.id || item.item_id || "256873000149972193",
          quantity: quantities[idx] || 1
        }))
      };

      console.log('payload:', payload);

      const { data } = await axios.post(
          `${base_url}api/zoho/salesorder`,
        payload
        ,getHeaders()
      );
      setResult(data);
      return data;
    } catch (err) {
      setError(err.message || 'Failed to create sales order');
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { createSalesOrder, loading, error, result };
};

// export default useSalesOrders;
export { useCreateSalesOrder };
